import React from "react";
import "./Map.css";

const Map = () => {
  return (
    <div className="map-container">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2994.602008544016!2d19.546603874575016!3d41.36100359763365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x134fd7160000d71b%3A0x6af4b27e4e9c0a56!2sUra%20%22Sule%20Golemit%22!5e0!3m2!1sen!2s!4v1783283578452!5m2!1sen!2s"  loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>
    </div>
  );
};

export default Map;